import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const useHomologarSpf = ({ selection }) => {
  const {
    request: requestHomologar,
    data: dataHomologar,
    errors: errorFormHomologar,
    isLoading: isLoadingHomologar,
  } = useApiClient();

  const homologaSpf = () => {
    if (selection) {
      const params = { listaSpfHomologar: selection };
      requestHomologar(apiRoutes.fiscalizacao.procedimentoFiscal.homologaProcedimentoFiscal, params);
    }
  };

  useEffect(() => {
    if (isLoadingHomologar) return;

    if (errorFormHomologar) {
      toast.error(errorFormHomologar.message);
    }
  }, [requestHomologar, errorFormHomologar, isLoadingHomologar, dataHomologar]);

  return { isLoadingHomologar, homologaSpf, errorFormHomologar, dataHomologar };
};

export default useHomologarSpf;
